module.exports = __webpack_public_path__ + "static/media/3.39a8e06e.jpeg";